







import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RenderPostModel } from "@/services/render/types";
import {
    DatePostProperties,
    DateStyle,
    FormatValue,
    CapitalizeEnum
} from "@/services/posts/postTypes/date";

import { Style } from "@/services/styles/types";
import moment from "moment";
import { TimeZone } from "@/services/timeZones/types";
import { getTimeZones } from "@/services/timeZones/timeZoneService";
import { setNextItem } from "../types";
import { renderDate } from "./dateFormatting";
import { Getter } from "vuex-class";
import i18n from "@/i18n";

@Component
export default class DateRender extends Vue {
    @Prop() private item!: RenderPostModel;
    @Prop() private itemStyle!: Style; // it's used only in style form preview
    @Prop() private active!: number;
    @Getter("render/getCurrentSolutionTimezoneId") currentSolutionTimezoneId!: string;

    currentDate = moment();
    renderDate = renderDate;

    setNextItemTimer = 0;
    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0) {
            this.currentDate = moment();
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(
                this.setNextItem,
                this.propertiesModel.showTime * 1000
            );
        }
    }

    timeZones: TimeZone[] = [];
    // Lyfecycle
    async created() {
        this.timeZones = await getTimeZones();
        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const localUtcOffset = browserLocation ? this.timeZones.find(x => x.displayName.includes(browserLocation.split("/")[1])) : null;
        this.timeZones.unshift({
            id: "localtime",
            displayName: i18n.t("posts.date.timezones.localTime"),
            baseUtcOffset: localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset.toString(),
            offset: localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString()
        } as TimeZone).toString();
        this.timeZones.unshift({
            id: "SolutionTimeZone",
            displayName: i18n.t("posts.date.timezones.solutionTimeZone"),
            baseUtcOffset: this.currentSolutionTimezone ? this.currentSolutionTimezone.baseUtcOffset : (localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset().toString()),
            offset: this.currentSolutionTimezone ? this.currentSolutionTimezone.offset : (localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString())
        } as TimeZone).toString();
        if (this.itemStyle) {
            this.currentDate = moment();
        }
        // Check for undefined timezone and set local timezone.
        if (this.propertiesModel.timeZone === "") {
            this.propertiesModel.timeZone = this.timeZones[0].id;
        } else if (this.propertiesModel.timeZone === undefined) {
            this.propertiesModel.timeZone = this.timeZones[1].id;
        }
    }

    get propertiesModel(): DatePostProperties {
        return this.item.properties
            ? (this.item.properties as DatePostProperties)
            : ({} as DatePostProperties);
    }

    get styleModel(): DateStyle {
        return this.item.css && Object.entries(this.item.css).length > 0 && this.item.css.constructor === Object ? this.item.css as DateStyle : this.itemStyle ? this.itemStyle.css as DateStyle : {} as DateStyle;
    }

    get currentSolutionTimezone() {
        for (const timezone of this.timeZones) {
            if (timezone.id === this.currentSolutionTimezoneId) {
                return timezone;
            }
        }
    }

    get utcOffset(): string {
        var timezone = this.timeZones.find(x => x.id.toLowerCase() === this.propertiesModel.timeZone.toLowerCase());
        var result = timezone ? timezone.offset.charAt(0) !== "-" ? "+".concat(timezone.offset) : timezone.offset : "";
        return result;
    }

    setNextItem() {
        this.$emit("setNextItem", { id: this.item.id } as setNextItem);
    }
}
